import { Icon, type IconProps } from './Icon';

export function InfinityIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M18.2 8.5c2.4 0 3.8 1.6 3.8 3.5s-1.4 3.5-3.8 3.5c-3.7 0-8.7-7-12.4-7C3.4 8.5 2 10.1 2 12s1.4 3.5 3.8 3.5c3.7 0 8.7-7 12.4-7z" />
    </Icon>
  );
}
